import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { PageProjectHistory } from '../page-project-history.js';

@customElement('branch-label')
export class BranchLabel extends LitElement {
  @consume({ context: contexts.project, subscribe: true }) private _project?: ContextType<typeof contexts.project>;
  @consume({ context: contexts.dataSnapshotId, subscribe: true }) private _snapshotId?: ContextType<typeof contexts.dataSnapshotId>;

  @property() name?: string;
  @property({ type: Boolean, reflect: true }) icon = false;

  override render() {
    if (!this.name)
      return nothing;
    const content = html`
      ${this.icon ? html`<sl-icon library=boxicons name=bx-git-branch></sl-icon>` : nothing}
      <span class=text>${this.name}</span>
    `;
    const href = this._project ? PageProjectHistory.url({
      orgSlug: this._project.org.orgSlug,
      projectSlug: this._project.projectSlug,
      head: this.name,
      snapshotId: this._snapshotId,
    }) : undefined;
    if (href)
      return html`<a class=body href=${href} title=${this.name}>${content}</a>`;
    return html`<span class=body title=${this.name}>${content}</span>`;
  }

  static styles = css`
    :host {
      display: inline-block;
      min-width: 2em;
      flex: auto;
    }
    .body {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      gap: var(--sl-spacing-2x-small);
      color: var(--sl-color-primary-600);
      background: var(--sl-color-primary-100);
      padding: var(--sl-spacing-2x-small);
      border-radius: var(--sl-border-radius-large);
      text-decoration: none;
      max-width: 100%;
    }

    sl-icon {
      flex: none;
    }

    .text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `;
}
